<div class="col-xs-12 col-md-6 col-md-offset-3">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title"><b>Vouchers adicionais para resgate:</b></h3>
    </div>
    <div class="panel-body">
      <p class="bg-info">Aqui estão os Vouchers para resgate na mesma transferência bancária, assim você pagará apenas
        uma tarifa de DOC/TED!</p>

      <div *ngFor="let voucher of voucherService?.vouchersAdicionais" class="table-responsive">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Número do Voucher</th>
              <th>Pontos</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ voucher.getNumero() }}
              </td>
              <td>{{ voucher.getSaldoPontos() }}</td>
              <td>
                <button (click)="removerVoucher(voucher)" type="button" class="btn app-btn-best">
                  <i class="fa fa-trash"></i> remover
                </button>
              </td>
            </tr>
            <tr *ngIf="voucherResgatarComponent.isVoucherInvalido(voucher)" class="alert alert-danger" role="alert">
              <td colspan="3">
                {{voucherResgatarComponent?.getMensagemInconsistencia(voucher)}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/voucher/voucher-resgatar/voucher-lista-adicionais/voucher-lista-adicionais.component.html